<template>
  <div :class="classObj" class="app-wrapper">
    <Menu class="sidebar-container" />
    <div v-if="sidebar.opened" @click="handleClickOutside" />
    <div class="main-container" v-wechat-title="'订单管理系统'">
      <navbar />
      <app-main />
    </div>
  </div>
</template>

<script>
import { Navbar, Menu, AppMain } from "./components";

export default {
  name: "Layout",
  components: {
    Navbar,
    Menu,
    AppMain,
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
      };
    },
  },
  beforeMount() {
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  mounted() {
    const isMobile = this.isMobile();
    if (isMobile) {
      this.$store.dispatch("changeSideBar", {
        opened: false,
        withoutAnimation: true,
      });
    }
  },
  methods: {
    isMobile() {
      const WIDTH = 992;
      const rect = document.body.getBoundingClientRect();
      return rect.width - 1 < WIDTH;
    },
    resizeHandler() {
      const isMobile = this.isMobile();
      if (isMobile) {
        this.$store.dispatch("changeSideBar", {
          opened: false,
          withoutAnimation: true,
        });
      } else if (!this.sidebar.opened) {
        this.$store.dispatch("changeSideBar", {
          opened: true,
          withoutAnimation: true,
        });
      }
    },
    handleClickOutside() {
      this.$store.dispatch("changeSideBar", {
        opened: false,
        withoutAnimation: false,
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "@/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>
